import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/HighlightOff';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { AcquirerActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const acquirersSelector = (state) => state.Acquirers;
const IdentitySelector = (state) => state.Identity;

const AcquirerRegistrationCompleted = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const acquirerActions = bindActionCreators(AcquirerActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(acquirersSelector);
    const { token, userData, permissions } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch, register } = useForm();

    const { classes, data } = props;

    /**
     *
     * 戻るボタン押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 解約ボタン押下時の処理
     *
     */
    const onCancellationClick = () => {
        props.onCancellation();
    }

    /**
     *
     * 編集ボタン押下時の処理
     *
     */
    const onEdit = (e) => {
        props.onEdit(e.currentTarget.id);
    }

    // 事業形態
    var businessForm = '';
    switch (editing.business_form) {
        case 1:
            // 法人
            businessForm = <FormattedMessage id={"Merchant.Corporate"} />;
            break;
        case 2:
            // 個人事業主
            businessForm = <FormattedMessage id={"Merchant.IndividualBusiness"} />;
            break;
    }

    // 法人種別コード種別
    var shopCdtype = '';
    switch (editing.shop_cd_type) {
        case 1:
            // OKICA独自
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeOkica"} />;
            break;
        case 2:
            // JPQR
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeJPQR"} />;
            break;
    }

    // 精算サイクル
    var paymentCycle = '';
    switch (editing.payment_cycle) {
        case 1:
            // 月1回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle1"} />;
            break;
        case 2:
            // 月2回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle2"} />;
            break;
        case 2:
            // 月4回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle3"} />;
            break;
    }

    // 代表者性別
    var delegateSex = '';
    switch (editing.delegate_sex) {
        case 1:
            // 男性
            delegateSex = <FormattedMessage id={"Merchant.SexMale"} />;
            break;
        case 2:
            // 女性
            delegateSex = <FormattedMessage id={"Merchant.SexFemale"} />;
            break;
    }

    // 口座種別
    var accountKbn = '';
    switch (editing.account_kbn) {
        case 1:
            // 普通
            accountKbn = <FormattedMessage id={"Merchant.AccountTypeSavings"} />;
            break;
        case 2:
            // 当座
            accountKbn = <FormattedMessage id={"Merchant.AccountTypeCurrent"} />;
            break;
    }

    // 設立年月日
    var establishmentDt = '';
    if (editing.establishment_dt != null && editing.establishment_dt != undefined) {
        var dt = new Date(editing.establishment_dt);
        establishmentDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 代表者生年月日
    var delegateBirthday = '';
    if (editing.delegate_birthday != null && editing.delegate_birthday != undefined) {
        var dt = new Date(editing.delegate_birthday);
        delegateBirthday = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 資本金
    var capital = '';
    if (editing.capital != null && editing.capital != undefined && editing.capital != '' && !isNaN(editing.capital)) {
        capital = Number(editing.capital).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }
    // 年商
    var annualSale = '';
    if (editing.annual_sale != null && editing.annual_sale != undefined && editing.annual_sale != '' && !isNaN(editing.annual_sale)) {
        annualSale = Number(editing.annual_sale).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }

    // 業種カテゴリー
    var categoryName = '';
    // 業種サブカテゴリー
    var subCategoryName = '';
    var matchedCategory = editing.merchantCategoryCodes.filter(category => category.category_code == editing.category_code);
    if (matchedCategory.length > 0) {
        categoryName = matchedCategory[0].category_name;
        var matchedSubCategory = matchedCategory.filter(category => category.subcategory_code == editing.subcategory_code);
        if (matchedSubCategory.length > 0) {
            subCategoryName = matchedSubCategory[0].subcategory_name;
        }
    }

    var disabledFlag = false;
    var cancellationButton = <div></div>;
    if (editing.status != 5) {
        // 解約以外は編集ボタンを表示可能
        if (userData.role == 1 || userData.role == 2) {
            // システム管理者および沖縄ICカードアカウント
            if (permissions.fid5_1 != null && (permissions.fid5_1.value.value & 2) == 2) {
                // 代表加盟店の権限（編集）付与されたアカウント（fid5_1：代表加盟店）
                cancellationButton =
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium" color="secondary"
                            onClick={onCancellationClick}
                            startIcon={<CancelIcon />}><FormattedMessage id="Button.Cancellation" /></Button>
                    </Grid>
            }
        }
    }
    else {
        // 5:解約の場合は、編集ボタンを非表示で詳細情報は表示
        disabledFlag = true;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2} >
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Acquirer.Title" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit" align="center">{editing.merchant_name}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepOne" />}</Typography>
                            <div>
                                <Button fullWidth variant="contained" size="medium" color="primary" id="0"
                                    disabled={disabledFlag}
                                    onClick={(e) => onEdit(e)}
                                    endIcon={<EditIcon />}>
                                    <FormattedMessage id="Button.Edit" />
                                </Button>
                            </div>
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FullName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FullNameFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Mail"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.mail_adress}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Department"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_depart}</InputLabel>
                    </Grid>

                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepTwo.Acquirer" />}</Typography>
                            <div>
                                <Button fullWidth variant="contained" size="medium" color="primary" id="1"
                                    disabled={disabledFlag}
                                    onClick={(e) => onEdit(e)}
                                    endIcon={<EditIcon />}>
                                    <FormattedMessage id="Button.Edit" />
                                </Button>
                            </div>
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{businessForm}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNameInFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel1"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_1}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel2"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_2}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{shopCdtype}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NameInEng"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_e_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PostalCode"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_postal_code}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Place"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_address}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FaxNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_fax}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Capital"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{capital}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AnnualSales"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{annualSale}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.EstablishDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{establishmentDt}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfEmployees"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.employees_number}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfStores"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.temp_number}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustryCategory"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{categoryName}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustrySubCategory"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{subCategoryName}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessDetail"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.business_content}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PaymentCycle"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{paymentCycle}</InputLabel>
                    </Grid>

                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepThree" />}</Typography>
                            <div>
                                <Button fullWidth variant="contained" size="medium" color="primary" id="2"
                                    disabled={disabledFlag}
                                    onClick={(e) => onEdit(e)}
                                    endIcon={<EditIcon />}>
                                    <FormattedMessage id="Button.Edit" />
                                </Button>
                            </div>
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FullName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.delegate_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.FullNameFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.delegate_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BirthDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{delegateBirthday}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PostalCode"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.delegate_postal_code}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Address"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.delegate_address}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.delegate_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Sex"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{delegateSex}</InputLabel>
                    </Grid>

                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepFour" />}</Typography>
                            <div>
                                <Button fullWidth variant="contained" size="medium" color="primary" id="3"
                                    disabled={disabledFlag}
                                    onClick={(e) => onEdit(e)}
                                    endIcon={<EditIcon />}>
                                    <FormattedMessage id="Button.Edit" />
                                </Button>
                            </div>
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.financialinstitution_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankCode"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.financialinstitution_cd}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BranchName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.branch_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BranchNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.branch_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{accountKbn}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.account_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountHolder"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.account_holder}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountHolderFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.account_f_holder}</InputLabel>
                    </Grid>

                    <Grid container item xs={12} spacing={2} justify="center">
                        <Grid item xs={6}>
                            <Button fullWidth variant="contained" size="medium"
                                startIcon={<ArrowBackIosIcon />}
                                onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                        </Grid>
                        {cancellationButton}
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(AcquirerRegistrationCompleted);
